<template>
    <div class="d-flex">
        <b-button
            title="Edit"
            variant="default"
            @click="handleEditCouponPackage"
        >
            <font-awesome-icon :icon="['fas', 'pen-to-square']"></font-awesome-icon>
        </b-button>
        <b-button
            class="ml-1"
            variant="default"
            title="Delete"
            @click="handleDeleteCouponPackage"
        >
            <font-awesome-icon :icon="['fas', 'trash']" />
        </b-button>
    </div>
</template>

<script>
export default {
    methods: {
        handleEditCouponPackage() {
            this.params.update && this.params.update(this.params.data);
        },
        handleDeleteCouponPackage() {
            this.params.delete && this.params.delete(this.params.data);
        }
    },
}
</script>
